export default function ConfirmAge() {
  const confirmAge = document.querySelector(".confirm-age");
  const btnYes = document.querySelector(".btn.yes");
  const btnNo = document.querySelector(".btn.no");
  if (document.cookie.includes("anticaAgeConfirmed=yes")) {
    confirmAge.style.display = "none";
  }
  btnYes.addEventListener("click", (e) => {
    e.preventDefault();
    confirmAge.style.display = "none";
    const date = new Date();
    date.setTime(date.getTime() + 1000 * 60 * 60 * 24 * 7);
    document.cookie = `anticaAgeConfirmed=yes; expires=${date.toGMTString()}`;
  });
  btnNo.addEventListener("blur", (e) => {
    e.preventDefault();
    btnYes.focus();
  });
}
